module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-dialog', {
    attrs: {
      "width": "50rem",
      "top": "2vh",
      "center": true,
      "show-close": false,
      "close-on-click-modal": true,
      "visible": _vm.showProfileDialog,
      "append-to-body": true
    },
    on: {
      "update:visible": function($event) {
        _vm.showProfileDialog = $event
      }
    }
  }, [_c('div', {
    staticClass: "profile-title",
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_c('span', {
    staticClass: "profile-controls"
  }, [_c('el-tooltip', {
    attrs: {
      "content": _vm.showBlacklisted ? 'Hide Blacklisted' : 'Show Blacklisted'
    }
  }, [_c('el-button', {
    style: (_vm.showBlacklisted ? 'color: white;' : ''),
    attrs: {
      "type": "text",
      "icon": "fa fa-ban"
    },
    on: {
      "click": function($event) {
        _vm.showBlacklisted = !_vm.showBlacklisted
      }
    }
  })], 1), _vm._v(" "), _c('el-tooltip', {
    attrs: {
      "content": _vm.showDeleted ? 'Hide Removed' : 'Show Removed'
    }
  }, [_c('el-button', {
    style: (_vm.showDeleted ? 'color: white;' : ''),
    attrs: {
      "type": "text",
      "icon": "fa fa-trash-o"
    },
    on: {
      "click": function($event) {
        _vm.showDeleted = !_vm.showDeleted
      }
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "avatar-container"
  }, [_c('img', {
    staticClass: "avatar-image",
    attrs: {
      "src": _vm.showFallbackProfileImage ? _vm.identicon : _vm.profileImage
    },
    on: {
      "error": _vm.profileImageError
    }
  })]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.profileName))])]), _vm._v(" "), _c('el-tabs', {
    staticStyle: {
      "width": "48rem",
      "margin": "auto -15px"
    },
    attrs: {
      "stretch": true
    },
    model: {
      value: (_vm.activeTab),
      callback: function($$v) {
        _vm.activeTab = $$v
      },
      expression: "activeTab"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "label": "Demographics",
      "name": "personal"
    }
  }, [_c('table', [_c('tbody', _vm._l((_vm.appendProfileFields(_vm.profile)), function(content, category) {
    return _c('tr', {
      key: category
    }, [(
      !_vm.excludeCategories.find(function (x) { return x === category; }) &&
      _vm.appendProfileFields(_vm.profile) &&
      _vm.showCategory(_vm.appendProfileFields(_vm.profile))
    ) ? _c('span', _vm._l((content), function(fields, key) {
      return _c('td', {
        key: key,
        staticStyle: {
          "display": "table-row"
        }
      }, [(!_vm.excludeProps.find(function (x) { return x === key; })) ? _c('ProfileDetailFieldItem', {
        key: (category + "-" + key),
        attrs: {
          "fieldKey": _vm.getKey(key),
          "category": category,
          "fields": _vm.filteredFields(fields),
          "profileId": _vm.profileId
        },
        on: {
          "removeNugget": _vm.handleRemoveNugget,
          "blacklistNugget": _vm.handleBlacklistNugget,
          "onShowProfileMap": _vm.handleShowProfileMap
        }
      }) : _vm._e(), _vm._v(" "), (key === 'location' && _vm.showProfileMap) ? _c('div', {
        staticClass: "mapouter"
      }, [_c('div', {
        staticClass: "gmap_canvas"
      }, [_c('iframe', {
        staticClass: "map_frame",
        attrs: {
          "id": "gmap_canvas",
          "src": ("https://maps.google.com/maps?q=" + _vm.location + "&z=10&output=embed"),
          "frameborder": "0",
          "scrolling": "no",
          "marginheight": "0",
          "marginwidth": "0"
        }
      }), _vm._v(" "), _c('a', {
        attrs: {
          "href": "https://www.embedgooglemap.net"
        }
      })])]) : _vm._e()], 1)
    }), 0) : _vm._e()])
  }), 0)])]), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "Interactions",
      "name": "interactions"
    }
  }, [(_vm.loadingInteractions[_vm.panelSettings.uuid] && !_vm.interactions(_vm.panelSettings.uuid).length) ? _c('loader', {
    attrs: {
      "message": "Loading interactions"
    }
  }) : _vm._e(), _vm._v(" "), _c('interactions-filter', {
    attrs: {
      "interactions": _vm.groupByInterationChannel(_vm.interactions(_vm.panelSettings.uuid)),
      "profile": _vm.profile
    },
    on: {
      "onFilterInteractions": _vm.handleFilterInteractions
    }
  }), _vm._v(" "), (!_vm.loadingInteractions[_vm.panelSettings.uuid]) ? _c('message-panel', {
    attrs: {
      "id": _vm.panelSettings.uuid,
      "polling": false,
      "title": 'Message history',
      "type": 'profile',
      "color": '#ee2465',
      "canClose": false,
      "hasSettings": false,
      "interactions": _vm.filterByChannelType(_vm.interactions(_vm.panelSettings.uuid)),
      "hasSearch": false,
      "isFixedPanel": true,
      "loadingSuccess": !!_vm.loadingInteractionsSuccess[_vm.panelSettings.uuid] || false,
      "loading": _vm.loadingInteractions[_vm.panelSettings.uuid] || false,
      "hasMoreInteractions": _vm.panelHasMoreInteractions(_vm.panelSettings.uuid) || false
    },
    on: {
      "loadMore": _vm.handleLoadMore
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "Campaigns & Surveys",
      "name": "Surveys"
    }
  }, [(_vm.loadingInteractions[_vm.panelSettings.uuid] && !_vm.interactions(_vm.panelSettings.uuid).length) ? _c('loader', {
    attrs: {
      "message": "Loading Campaigns & Surveys"
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.loadingInteractions[_vm.panelSettings.uuid]) ? _c('el-table', {
    staticStyle: {
      "width": "100%",
      "font-size": "13px"
    },
    attrs: {
      "data": _vm.formatCampaignSurveysData()
    }
  }, [_c('el-table-column', {
    attrs: {
      "sortable": "",
      "label": "Title",
      "prop": "title"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "sortable": "",
      "label": "Type",
      "prop": "type"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "sortable": "",
      "label": "Date",
      "prop": "startDate"
    }
  })], 1) : _vm._e()], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.showProfileDialog = false
      }
    }
  }, [_vm._v("Close")])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-eb1d42ec","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/string-replace-loader?{"multiple":[{"search":"logo-white[.]svg","replace":"logo-white-live.svg","flags":"g"},{"search":"_variables","replace":"_variables_live","flags":"g"},{"search":"_theme","replace":"_live","flags":"g"}]}!./src/components/profile/ProfileDetailDialog.vue
// module id = 3418
// module chunks = 3